import angular from 'angular';

import directive from './report-instances.directive';
import controller from './report-instances.controller';

import reportInstance from './reportInstance';

export default angular.module('app.components.reports.archivedReports.reportType.reportInstances', [
  reportInstance
])
  .directive('archivedReportInstances', directive)
  .controller('ArchivedReportInstancesController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportType.reportInstances created');
